import React, { Suspense } from "react";
import axios from "axios";
import { Provider } from "react-redux";
import reducer from "./store/reducer";
import { createStore } from "redux";
import Loader from "./components/Loader/Loader";
import { axiosIntercept, getUserData, _fetchIpLocationOnLogin, _getCookieValue, _getOrSetIpLocation, _sanitizeWEevent, _setCookieValue, _universal_logger_v2, _pageEnterTime, _pageExitTime, parseJwt, _generateUUID, getLsValues } from "./Helper/commonFunctions_v2";
import { _isMobile, _mathTOFixedNoRounding, _removeURLParam } from "./util/commonFunctions";
import { getPendingQCUpdates } from "./util/OfflinePendingReqs/OfflinePendingReqs";
import { ChatProvider } from "./contexts/ChatContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import { Toaster } from "sonner";
import "./App.css";

const store = createStore(reducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()),
    Routes = React.lazy(() => import("./Layout/Routes"));

export default class App extends React.Component {
    state = {
        loginCheck: false,
        loggedIn: false,
        key: false,
        postMessage: "test",
        offlineSync: {
            display: false,
            type: "QC",
            count_name: "Qc",
            count: 0,
            success: false,
            error: false,
            begin_unmount: false,
        },
    };

    popStateListener = (event) => {
        window.isPopState = { value: true, key: window?.history?.state?.key };
    };

    checkSetHistoryState = () => {
        window.history.replaceState(
            {
                key: "start1",
                state: "firstCheck",
            },
            !1,
            window.location.href,
        );
        this.setState({ key: true });
    };

    loginOnToken = () => {
        let urlParams = new URLSearchParams(this.props.location && this.props.location.search);
        //  check for token of different user than who is logged in
        let userData = getUserData();
        let token = urlParams.get("token");
        try {
            let tokenData = parseJwt(token);
            if (tokenData?.userId && userData?.userId && tokenData?.userId !== userData?.userId) {
                _universal_logger_v2({
                    eventName: "Token_Different_User_Login_Not_Allowed",
                    businessDataObj: {
                        token_from_url: token,
                        token_from_url_data: tokenData,
                        token_from_logged_in_user: getLsValues()?.token,
                        token_from_logged_in_user_data: parseJwt(getLsValues()?.token),
                        ...tokenData,
                    },
                    passedThis: this,
                });
            }
        } catch (error) {
            console.log("error", error);
        }

        // Check for campaignName in URL and log event
        if (urlParams.has("campaignName")) {
            let campaignName = urlParams.get("campaignName");
            _universal_logger_v2({
                eventName: "Campaign_URL_Accessed",
                businessDataObj: {
                    campaignName: campaignName,
                    url: window?.location?.href,
                    pathname: window?.location?.pathname,
                    search: window?.location?.search,
                    token_present: urlParams.has("token"),
                    fromQCApp: urlParams.has("fromQCApp"),
                },
                triggerInfoObj: {
                    source: "loginOnToken",
                    page: window?.location?.pathname,
                },
                passedThis: this,
            });
        }

        if (urlParams.has("token") && (!getUserData()?.userId || urlParams.has("fromQCApp"))) {
            this._log_login_on_token(urlParams.get("token"));
            window.localStorage.setItem("token", urlParams.get("token"));
            if (urlParams.has("refresh_token")) {
                window.localStorage.setItem("refresh_token", urlParams.get("refresh_token"));
            }
            void _fetchIpLocationOnLogin();
            _pageEnterTime({ passedThis: this }, "Portal View Page");
            let newUrl = _removeURLParam("token", window.location.href);
            newUrl = _removeURLParam("refresh_token", newUrl);
            window.history.replaceState({}, null, newUrl);
        } else {
            _pageEnterTime({ passedThis: this }, "Portal View Page");
        }
    };

    _log_login_on_token = (token) => {
        _universal_logger_v2({
            eventName: "Token_Login",
            businessDataObj: {
                token,
                is_token_login: true,
                ...parseJwt(token),
            },
            entityTypeObj: {
                page: "App",
                type: "token_login",
                token,
                ...parseJwt(token),
            },
            triggerInfoObj: {
                Class: "App",
                function: "_log_login_on_token",
            },
            passedThis: this,
        });
    };

    _initial_func = () => {
        if (!!window) {
            if (window?.localStorage?.getItem("tnaAudit")) {
                let date = new Date(),
                    time = date.getTime(),
                    lastViewPopTime = window?.localStorage?.getItem("tnaAudit");
                let difference_time = lastViewPopTime ? time - lastViewPopTime : 0;
                if (difference_time > 18000000) {
                    localStorage.removeItem("tnaAudit");
                }
            }
            if (window?.localStorage?.getItem("showFactoryDocOverlay")) {
                let date = new Date(),
                    time = date.getTime(),
                    lastViewPopTime = window?.localStorage?.getItem("showFactoryDocOverlay");
                let difference_time = lastViewPopTime ? time - lastViewPopTime : 0;
                if (difference_time > 18000000) {
                    localStorage.removeItem("showFactoryDocOverlay");
                }
            }
            if (_getCookieValue("ipLocation")) _setCookieValue("ipLocation", "", -1);
            window.searchKeys = {};
            window.onpopstate = this.popStateListener;
            !window?.history?.state?.key && this.checkSetHistoryState();
            window?.history?.state?.key && this.setState({ key: true });
            axiosIntercept(axios);
            window.webengage && window.webengage.track && window.webengage.track("portalView", { url: window.location.href, react: true });
            document?.referrer?.includes("android-app://") && localStorage.setItem("inAnroidApp", true);
            // let Eventobject = {hello: "", world: null, hritik: undefined, prateek: {first: null, second: undefined, third: "", fourth: {1: "", 2: null, 3: undefined, 4: [1,2,3], 5: [] , 6: "yo", 7: "  ", 8: 123}}};
            // console.log("_sanitizeWEevent(obj)", _sanitizeWEevent(Eventobject));
            // if(navigator.onLine) setTimeout(() => getPendingQCUpdates(this), 3000); // Delaying for dramatic effect and leaving scope to make it faster later :P
            window.addEventListener("online", (e) => {
                console.log("online");
                getPendingQCUpdates(this);
            });
            window.time_spent = {
                page_timer_map: {},
                last_page: "",
                inactivity_time: 0,
                tab_start_time: 0,
                tab_end_time: 0,
                tab_id: _generateUUID(),
                tab_focus_count: 0,
                tab_time_spent: 0,
            };
            window.addEventListener("blur", (e) => {
                // console.log("tab blur at -> ", new Date().toString());
                _universal_logger_v2({ eventName: "tab_end" });
            });
            window.addEventListener("focus", (e) => {
                // console.log("tab focus at -> ", new Date().toString());
                _universal_logger_v2({ eventName: "tab_start" });
            });
        }
    };

    componentDidMount() {
        this.loginOnToken();
        _mathTOFixedNoRounding();
        // ipLocation: UMS geo/me when logged in; employees may refine via browser GPS prompt.
        _getOrSetIpLocation();
        this._initial_func();
    }

    componentWillUnmount() {
        _pageExitTime({ passedThis: this }, "Portal View Page");
    }

    render() {
        let { key, postMessage, offlineSync } = this.state;
        return (
            <React.Fragment>
                <Provider store={store}>
                    <NotificationProvider>
                        <ChatProvider location={this.props.location}>
                            <Toaster richColors position="top-left" visibleToasts={3} expand={!_isMobile()} />
                            <Suspense fallback={<Loader />}>{key && <Routes offlineSync={offlineSync} />}</Suspense>
                        </ChatProvider>
                    </NotificationProvider>
                </Provider>
            </React.Fragment>
        );
    }
}
